import { get } from "utils/request";
import type {
  Article,
  ArticleListResponse,
  ApiResponse,
  SearchParams,
  PaginationParams,
} from "types/api";

/**
 * 获取文章列表
 * @param page 页码
 * @param pageSize 每页数量
 */
export const getArticlesList = (
  page: number,
  pageSize: number = 8,
): Promise<ApiResponse<ArticleListResponse>> => {
  const params: PaginationParams = {
    page_no: page,
    page_size: pageSize,
  };
  return get<ArticleListResponse>("/markdown/lists", params);
};

/**
 * 获取最新文章
 */
export const getNewArticles = (): Promise<ApiResponse<Article[]>> => {
  return get<Article[]>("/markdown/newList");
};

/**
 * 获取推荐文章列表
 */
export const getRecommendArticles = (): Promise<ApiResponse<Article[]>> => {
  return get<Article[]>("/markdown/recommendList");
};

/**
 * 获取文章详情
 * @param id 文章ID
 */
export const getArticleDetail = (id: string): Promise<ApiResponse<Article>> => {
  return get<Article>("/markdown/detail", { id });
};

/**
 * 搜索文章
 * @param keyword 搜索关键词
 */
export const searchArticles = (
  keyword: string,
): Promise<ApiResponse<Article[]>> => {
  const params: SearchParams = { search: keyword };
  return get<Article[]>("/markdown/Search", params);
};

// 保持向后兼容的导出（可选）
export const ArticlesList = getArticlesList;
export const newArticles = getNewArticles;
export const recommendArticles = getRecommendArticles;
export const detailArticle = getArticleDetail;
export const searchArticle = searchArticles;
